import type {
  GeneratedAsset,
  GeneratedAssetTool,
  ListGeneratedAssetsResponse,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const assetLibraryApi = {
  async list(businessId: string, tool?: GeneratedAssetTool): Promise<GeneratedAsset[]> {
    const res = await api.api.businesses[':businessId']['ai-studio'].assets.$get({
      param: { businessId },
      query: tool ? { tool } : {},
    })
    const data = await unwrap<ListGeneratedAssetsResponse>(res)
    return data.assets
  },
  async remove(businessId: string, assetId: string): Promise<void> {
    const res = await api.api.businesses[':businessId']['ai-studio'].assets[':assetId'].$delete({
      param: { businessId, assetId },
    })
    await unwrap<void>(res)
  },
}
